import { Snackbar, Box, Theme, makeStyles } from "@material-ui/core";
import strings from "../../../global/constants/StringConstants";
import clsx from "clsx";
import { useAppSelector } from "../../../utils/hooks";
import { selectIsUTTLocked } from "../../../redux/generalSlice";
import { getRelativeFontSize, regularFont } from "../../../utils/styles";

const customClassesStyle = makeStyles(
  (theme: Theme) => ({
    notificationBlock: {
      backgroundColor: "#d84646",
      color: "white !important",
      width: "100%",
      padding: "5px",
      display: "flex",
      borderRadius: "10px",
    },
    iconBlock: {
      height: "100%",
      width: "10%",
      display: "flex",
      alignItems: "flex-start",
    },
    notificationTitle: {
      fontSize: getRelativeFontSize(4),
    },
    messageBox: {
      ...regularFont,
      paddingTop: "5px",
      fontSize: getRelativeFontSize(2),
      wordBreak: "break-word",
    },
    messageContainer: {
      width: "80%",
    },
    closeNotification: {
      cursor: "pointer",
      // float: "right",
    },
  }),
  { index: 1 }
);

const UTTLocked = () => {
  const classes = customClassesStyle();
  const isUTTLocked = useAppSelector(selectIsUTTLocked);

  return (
    <Snackbar
      open={isUTTLocked}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      autoHideDuration={strings.autoHideDuration}
      onClose={() => {}}
    >
      <Box className={classes.notificationBlock}>
        <Box
          p={1}
          className={clsx(classes.iconBlock, classes.messageContainer)}
          alignItems="center"
        >
          <Box>
            <Box className={classes.notificationTitle}>Order updates</Box>
            <Box className={classes.messageBox}>
              We are processing the updates. Please wait!
            </Box>
          </Box>
        </Box>
      </Box>
    </Snackbar>
  );
};

export default UTTLocked;
